<template>
  <v-autocomplete
    v-bind="$attrs"
    :items="lazyItems"
    :loading="loadingAllItems"
    v-on="$listeners"
    @focus="onFocus"
  ></v-autocomplete>
</template>

<script>
import { mapState } from "vuex"

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    preselect: {
      type: String,
      default: "",
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    extraParams: {
      type: Object,
      default: undefined,
    },
    itemsFilter: {
      type: Function,
      default: undefined,
    },
  },
  computed: {
    lazyItems() {
      if (this.preselect && this.allItems.length === 0) {
        return [
          {
            [this.$attrs["item-text"]]: this.preselect,
            [this.$attrs["item-value"]]: this.$attrs.value,
          },
        ]
      }

      if (this.itemsFilter) {
        return this.allItems.filter(this.itemsFilter)
      }

      return this.allItems
    },
    ...mapState({
      loadingAllItems(state) {
        return (
          state[this.model.appName]?.pending[
            `all${this.model.modelNamePlural}`
          ] || false
        )
      },
      allItems(state) {
        return (
          state[this.model.appName]?.[`all${this.model.modelNamePlural}`] || []
        )
      },
    }),
  },
  created() {
    if (!this.lazy) {
      this.init()
    }
  },
  methods: {
    fetch() {
      if (this.extraParams) {
        this.$store.dispatch(`listAll${this.model.modelNamePlural}`, {
          params: this.extraParams,
        })
      } else {
        this.$store.dispatch(`listAll${this.model.modelNamePlural}`)
      }
    },
    init() {
      this.fetch()
    },
    onFocus() {
      if (this.lazy) {
        this.init()
      }
    },
  },
}
</script>
